import type { ComponentMeta } from "@mijalowcode/types";
import { ComponentCategory, PropType } from "@mijalowcode/types";

export const PaginationMeta: ComponentMeta = {
  componentName: "Pagination",
  package: "@mijadesign/web",
  title: "分页",
  description: "分页组件，用于展示数据分页",
  category: ComponentCategory.NAVIGATION,
  icon: "UnorderedListOutlined",
  canHaveChildren: false,
  props: [
    {
      name: "current",
      label: "当前页码",
      type: PropType.NUMBER,
      defaultValue: 1,
      group: "状态",
    },
    {
      name: "pageSize",
      label: "每页条数",
      type: PropType.NUMBER,
      defaultValue: 10,
      group: "配置",
    },
    {
      name: "total",
      label: "总条数",
      type: PropType.NUMBER,
      defaultValue: 0,
      group: "数据",
    },
    {
      name: "defaultCurrent",
      label: "默认当前页",
      type: PropType.NUMBER,
      defaultValue: 1,
      group: "默认",
    },
    {
      name: "defaultPageSize",
      label: "默认每页条数",
      type: PropType.NUMBER,
      defaultValue: 10,
      group: "默认",
    },
    {
      name: "pageSizeOptions",
      label: "每页条数选项",
      type: PropType.ARRAY,
      defaultValue: ["10", "20", "50", "100"],
      group: "配置",
    },
    {
      name: "showSizeChanger",
      label: "显示条数切换器",
      type: PropType.BOOLEAN,
      defaultValue: true,
      group: "展示",
    },
    {
      name: "showQuickJumper",
      label: "显示快速跳转",
      type: PropType.BOOLEAN,
      defaultValue: false,
      group: "展示",
    },
    {
      name: "showTotal",
      label: "显示总数",
      type: PropType.BOOLEAN,
      defaultValue: false,
      group: "展示",
    },
    {
      name: "simple",
      label: "简洁模式",
      type: PropType.BOOLEAN,
      defaultValue: false,
      group: "样式",
    },
    {
      name: "disabled",
      label: "禁用",
      type: PropType.BOOLEAN,
      defaultValue: false,
      group: "状态",
    },
    {
      name: "size",
      label: "尺寸",
      type: PropType.ENUM,
      defaultValue: "default",
      options: [
        { label: "默认", value: "default" },
        { label: "小", value: "small" },
      ],
      group: "样式",
    },
  ],
  defaultProps: {
    current: 1,
    pageSize: 10,
    total: 0,
    showSizeChanger: true,
  },
  npm: {
    package: "@mijadesign/web",
    exportName: "Pagination",
  },
  snippet: {
    componentName: "Pagination",
    package: "@mijadesign/web",
    props: { current: 1, pageSize: 10, total: 0 },
  },
};
